require('../../../modules/esnext.string.at');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').at;
